import React from 'react';

import { Messages } from '../../../../codegen/Localize';
import { FormikCheckbox } from '../../../../commonInfra/components/FormikCheckbox';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { SettingsSection } from '../../../components/common/SettingsSection';
import { groupNameMessage } from '../../../styles/CommonStyles';
import { componentRegistryEntry } from '../SettingsComponentRegistryFunctions';
import { SiteSettingsForSiteAdminProps } from '../site-settings/ReactSiteSettingsForSiteAdmin';
import { forceUncheckedIfUserVisibilityLimited, useUserVisibilityLimited } from './UserVisibilitySection';

export const DATA_ALERTS_FIELD = 'settings.dataAlertsEnabled';

export type DataAlertsSectionProps = SiteSettingsForSiteAdminProps<'dataAlertsEnabled' | 'userVisibility'>;

export function DataAlertsSection() {
  const isUserVisibilityLimited = useUserVisibilityLimited();
  return FeatureFlags.alertOnThresholdConditionEnabled
    ? (
      <SettingsSection title={renderTitle(isUserVisibilityLimited)}
                       testId={'data-alerts-setting-section'}
                       description={Messages.dataAlertsSiteSettingsDetails()}
                       disabled={isUserVisibilityLimited}>
        <FormikCheckbox
                        name={DATA_ALERTS_FIELD}
                        label={Messages.dataAlertsSiteSettingsEnable()}
                        testId={'data-alerts-enabled'}
                        disabled={isUserVisibilityLimited}
                        {...forceUncheckedIfUserVisibilityLimited(isUserVisibilityLimited)}
        />
      </SettingsSection>
    )
    : null;
}

function renderTitle(isUserVisibilityLimited: boolean) {
  return <>
    <span>{Messages.dataAlertsSiteSettings()}</span>
    {isUserVisibilityLimited &&
    <span className={groupNameMessage} data-tb-test-id={'dataalerts-uservisibility-warning'}>
      {Messages.userVisibilityWarning()}
    </span>}
  </>;
}

export const DataAlertsSectionSpecs = componentRegistryEntry({
  name: 'DataAlertsSection',
  component: DataAlertsSection
});
